import { Component, OnInit } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { IResponsible, IResponsibleUser, ResponsibleType } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-responsible-info',
    templateUrl: './admin-responsible-info.component.html',
    styleUrls: ['./admin-responsible-info.component.scss'],
    standalone: false
})
export class AdminResponsibleInfoComponent extends AdminActionsDirective implements OnInit {
    ResponsibleType = ResponsibleType;
    mainResponsible: IResponsibleUser[];
    otherResponsible: IResponsibleUser[];
    mainSpecialist: IResponsibleUser[];
    otherSpecialists: IResponsibleUser[];

    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }

    ngOnInit(): void {
        this.mainResponsible = this.item.responsible.filter(e => e.fullAccess);
        this.otherResponsible = this.item.responsible.filter(e => !e.fullAccess);
        this.mainSpecialist = this.item.specialists.filter(e => e.fullAccess);
        this.otherSpecialists = this.item.specialists.filter(e => !e.fullAccess);
    }

    get item(): IResponsible {
        return this.selectedItem;
    }
}
